
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MenuItemProps } from ".";
import { loading, create } from "store/menu";

interface ApiMenuCreateInputProps extends Omit<MenuItemProps, "id"> {
}

type ApiMenuCreateOutputProps = OutputBaseProps<{ item: MenuItemProps; }, ApiMenuCreateInputProps>

export const apiMenuCreate = async (data: ApiMenuCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiMenuCreateOutputProps>("/api/menu/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};